import styled from '@emotion/styled';

export const Container = styled.div({
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
});

export const ProfileImg = styled.img({
  width: '100px',
  height: '100px',
  borderRadius: '50%',
  margin: '1em 0',
});
